import { createSlice, PayloadAction } from "@reduxjs/toolkit";

const initialState = {
  update: { updating: false, success: false },
  blockdata: { updating: false, success: false },
  data: {
    data: [],
    tablelength: 0,
    logoutcount: 0,
    availablecount: 0,
    leavecount: 0,
    ondutycount: 0,
    blockedcount: 0,
    todaycount: 0,
  },
  loading: false,
  error: null,
};

const DriverAttenSlice = createSlice({
  name: "DriverAtten",
  initialState,
  reducers: {
    fetchDriverAttenRequest(state) {
      state.loading = true;
      state.error = null;
    },
    fetchDriverAttenSuccess(state, action) {
      state.loading = false;
      state.data = action.payload;
    },
    fetchDriverAttenFailure(state, action) {
      state.loading = false;
      state.error = action.payload;
    },
    fetchBlockDriverAttenRequest(state) {
      state.loading = true;
      state.error = null;
    },
    fetchBlockDriverAttenSuccess(state, action) {
      state.loading = false;
      state.blockdata = action.payload;
    },
    fetchBlockDriverAttenFailure(state, action) {
      state.loading = false;
      state.error = action.payload;
    },
    BlockedCabRequest(state) {
      state.update = { updating: true, success: false };
    },
    BlockedCabSuccess(state: any, action) {
      state.update = { updating: false, success: true };
    },
    BlockedCabFailure(state, action) {
      state.update = { updating: false, success: false };
    },
    // ActiveCabRequest(state) {
    //   state.update = { updating: true, success: false };
    // },
    // ActiveCabSuccess(state: any, action) {
    //   state.update = { updating: false, success: true };
    // },
    // ActiveCabFailure(state, action) {
    //   state.update = { updating: false, success: false };
    // },
  },
});
export const {
  fetchDriverAttenRequest,
  fetchDriverAttenSuccess,
  fetchDriverAttenFailure,
  fetchBlockDriverAttenRequest,
  fetchBlockDriverAttenSuccess,
  fetchBlockDriverAttenFailure,
  BlockedCabRequest,
  BlockedCabSuccess,
  BlockedCabFailure,
  // ActiveCabRequest,
  // ActiveCabSuccess,
  // ActiveCabFailure,
} = DriverAttenSlice.actions;
export default DriverAttenSlice.reducer;
